import React, { useState } from "react";
import { useQuery, useMutation } from "react-query";
import firebase from "firebase";
import Button from "../../components/Button";
import "react-datepicker/dist/react-datepicker.css";
import { Klass, Student } from "../../types";
import { nanoid } from "nanoid";
import Wrapper from "../../components/Layout/Wrapper";
import { Input } from "antd";
import useStudents from "../../hooks/useStudents";
import useAuth from "../../hooks/useAuth";

const Students = () => {
  const { accountDetails } = useAuth();
  const [search, setSearch] = useState("");
  const [newStudent, setNewStudent] = useState({ name: "", email: "" });
  const { isLoading, error, data, refetch } = useStudents();

  const { data: classData } = useQuery<Klass[]>("classes", () =>
    firebase
      .firestore()
      .collection("classes")
      .get()
      .then((snapshot) => {
        const classes: Klass[] = [];
        snapshot.forEach((doc) => {
          const data = doc.data() as Student;
          classes.push({ ...data, id: doc.id });
        });
        return classes;
      })
  );

  const { mutate: addStudentToFirestore } = useMutation(
    "students",
    async () => {
      const id = nanoid();
      await firebase.firestore().collection("students").doc(id).set({
        id: id,
        name: newStudent.name,
        email: newStudent.email.toLowerCase(),
      });
    },
    {
      onSuccess: () => {
        setNewStudent({ name: "", email: "" });
        refetch();
      },
    }
  );

  if (isLoading) {
    return <div>Loading</div>;
  }

  if (error) {
    return <div>ERROR: {JSON.stringify(error)}</div>;
  }

  if (!data) {
    return <div>No data</div>;
  }

  return (
    <div>
      <Wrapper style={{ flexDirection: "column", marginTop: 32 }}>
        <h1>Students</h1>
        <Input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search"
        />
        <table className="yc-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Email</th>
              <th>Username</th>
              <th>Registered?</th>
              <th>Classes</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data
              .filter((x) =>
                search
                  ? x.name.toLowerCase().includes(search.toLowerCase()) ||
                    x.email.toLowerCase().includes(search.toLowerCase())
                  : true
              )
              .filter((x) => {
                if (accountDetails?.isSuperuser) {
                  return true;
                }
                const studentClasses = classData?.filter((kl) =>
                  kl.students?.some((stu) => stu.id === x.id)
                );
                return studentClasses?.some((kl) =>
                  kl.teachers?.some((t) => t.teacherId === accountDetails?.id)
                );
              })
              .map((student) => (
                <tr>
                  <td>{student.name}</td>
                  <td>{student.email}</td>
                  <td>{student.username}</td>
                  <td>{student.uid ? "Yes" : "No"}</td>
                  <td>
                    {(classData || [])
                      .filter((x) =>
                        x.students?.some((stu) => stu.id === student.id)
                      )
                      .map((klass) => (
                        <div>{klass.name}</div>
                      ))}
                  </td>
                  <td></td>
                </tr>
              ))}
            {accountDetails?.isSuperuser && (
              <tr>
                <td>
                  <Input
                    placeholder="Name"
                    value={newStudent.name}
                    onChange={(e) =>
                      setNewStudent({ ...newStudent, name: e.target.value })
                    }
                  />
                </td>
                <td>
                  <Input
                    placeholder="Email (can be fake)"
                    value={newStudent.email}
                    onChange={(e) =>
                      setNewStudent({ ...newStudent, email: e.target.value })
                    }
                  />
                </td>
                <td></td>
                <td></td>
                <td></td>
                <td>
                  <Button
                    small
                    variant="secondary"
                    onClick={() => addStudentToFirestore()}
                  >
                    Add
                  </Button>
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <p>
          Note: you cannot delete users from here - please ask an admin to do so
          for you.
        </p>
      </Wrapper>
    </div>
  );
};

export default Students;
